import React from "react";
import PropTypes from "prop-types";
import styles from "./CustomNameTab.module.css";

function CustomNameTab({ header1, header2, body }) {
  return (
    <div>
      <div className={styles.header}>
        <div className={styles.headerItem}>{header1}</div>
        <div className={`${styles.headerItem} ${styles.rightAligned}`}>
          Cost Center: {header2}
        </div>
      </div>
      {body}
    </div>
  );
}

CustomNameTab.propTypes = {
  header1: PropTypes.string,
  header2: PropTypes.string,
  body: PropTypes.node,
};

export default CustomNameTab;
